import React from 'react';
import { Icon, Tooltip } from 'antd';
import DateFormatter from '../../utils/DateFormatter';

export default (bottle) => {
  bottle.factory('keyManagerColumns', () => StyledLastSix => [
    {
      title: () => (
        <Tooltip title="Voicebase only remembers the last 6 digits to help you with API key management.">
            Truncated Token <Icon type="question-circle" theme="filled" />
        </Tooltip>
      ),
      key: 'lastSix',
      dataIndex: 'lastSix',
      render: (text, record) => (!(record.lastSix) ? '--' : <StyledLastSix>{record.lastSix}</StyledLastSix>),
    },
    {
      title: 'Date Generated',
      key: 'issued',
      align: 'left',
      filtered: true,
      filterDropdownVisible: true,
      sorter: (a, b) => new Date(b.issued) - new Date(a.issued),
      render: (text, record) => DateFormatter.formatUtc(record.issued),
    },

  ]);
};
